<template>
  <el-dialog
    :append-to-body="true"
    :title="'添加成员'"
    :visible.sync="visible"
    top="4%"
    width="660px"
    height="100px"
    id="add-org-group"
    :before-close="modalClose"
  >
    <div class="dialog-body">
  
      <div class="checked-list-select">
          <el-form :model="form" :rules="rules" class="wrapper-form1"  label-position="left"  label-width="80px" ref="form">
            <el-form-item class="item" prop="selectTeam" label="小组分类">
                <el-select @change="changeTeam" v-model="form.selectTeam" placeholder="请选择小组分类" class="option-select">
                  <el-option v-for="item in personOptions" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="item" prop="staffName" label="员工">
              <el-input
                placeholder="请选择员工"
                v-model="form.staffName"
                :readonly="true"
                @focus="onFocus"
                >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="modalClose">取 消</el-button>
      <el-button type="primary" @click="closePerDialog">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { organizations, searchUser } from './org';
import { dictWithUrl } from '@/components/otpPanel/api';
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        tableData: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            imgUrl: require('@/components/lots/Dialog/img/zuzhi.png'),
            input4:'',
            orgShow: false,
            personNum: 0,
            searchPer: '',
            closeTable: [],
            personList: [],
            seletPerson: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            form: { selectTeam: '' ,staffName:'' },
            rules: {
                selectTeam: [{ required: true, message: '请选择小组分类', trigger: 'change' }],
                staffName: [{ required: true, message: '请选择员工', trigger: 'change' }],
            },
            personOptions: [] // 数字字典
        };
    },
    computed: { // 获取vuex
        loginState: function() {
            return this.$store.state.bidData;
        }
    },
    mounted() {
        this.closeTable = JSON.parse(JSON.stringify(this.tableData));// 防止删增成员没点保存
        this.GROUP_CLASSIFICATION();
        this.init();
    },
    methods: {

      onFocus() {
        this.$emit('onFocus',this.form.staffName);
      },
      async init() {
        // 初始化
        this.seletPerson = [];
        this.personNum = 0;
        this.personList = [];
        this.search();
        // this.$refs.tree.filter('');
        // this.$refs.tree.setCheckedKeys([]);
      },
        async GROUP_CLASSIFICATION() {
            const res = await dictWithUrl('BID_GROUP_CLASSIFICATION');
            for (const key in res.data.BID_GROUP_CLASSIFICATION) {
                if (key) {
                    const obj = {};
                    obj.value = key;
                    obj.label = res.data.BID_GROUP_CLASSIFICATION[key];
                    if (!this.loginState.isShowTab && this.loginState.syntheticalScore === 'N' && (obj.value === '30' || obj.value === '40')) {
                        obj.disabled = true;
                    }
                    this.personOptions.push(obj);
                }
            }
        },
        modalClose() {
            this.$emit('update:visible', false); // 直接修改父组件的属性
        },
        // 确认按钮
        closePerDialog() {
            this.$refs['form'].validate(async valid => {
                if (valid) {
                    this.$emit(
                        'perDetermine',
                        this.form.selectTeam,
                        false
                    );
                } else {
                    this.$message({
                        showClose: true,
                        message: '请选择小组分类和员工！',
                        type: 'error'
                    });
                }
            });
        },


        // 搜索
        search() {
            searchUser({ queryParam: this.searchPer }).then(res => {
                if (res && res.code === '0') {
                    this.personList = [];
                    const arr = res.data.list;
                    arr.forEach(item => {
                        const a = this.seletPerson.filter(
                            e => e.userCode === item.userCode
                        );
                        if (a.length > 0) {
                            item.isCheck = true;
                        } else {
                            item.isCheck = false;
                        }
                        this.personList.push(item);
                    });
                }
            });
        },
        loadNode(node, resolve) {
            if (node.level === 0) {
                organizations().then(res => {
                    if (res.data) {
                        return resolve(res.data);
                    }
                });
                return false;
            } else {
                organizations({ parentCode: node.data.code }).then(res => {
                    if (res.data) {
                        return resolve(res.data);
                    } else {
                        return resolve([]);
                    }
                });
            }
        },
        treeContent(h, { node, data, store }) {
            return (
                <span>
                    <img src={this.imgUrl} style="vertical-align: text-top;" />
                    <span style="margin-left:5px" class="showHighlight">
                        {node.label}
                    </span>
                </span>
            );
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        nodeClick(data, node, obj) {
            organizations({
                tenantFlag: 0,
                withUserFlag: 1,
                code: node.data.code
            }).then(res => {
                if (res && res.code === '0') {
                    this.personList = [];
                    const arr = res.data[0].users;
                    arr.forEach(item => {
                        const a = this.seletPerson.filter(
                            e => e.userCode === item.userCode
                        );
                        if (a.length > 0) {
                            item.isCheck = true;
                        } else {
                            item.isCheck = false;
                        }
                        this.personList.push(item);
                    });
                }
            });
        },
        async init() {
            this.seletPerson = this.closeTable;
            this.personNum = this.closeTable.length;
        },
        // 小组分类下拉框选择
        changeTeam(val) {
            this.form.selectTeam = val;
            this.form.staffName = '';
            this.$emit('on-type-change',this.form);
        },
        checkPerson(item) {
            if (item.isCheck) {
                const a = this.seletPerson.filter(e => {
                    return e.userCode !== item.userCode;
                });
                this.seletPerson = a;
                this.seletPerson.push(item);
            } else {
                const b = this.seletPerson.filter(e => {
                    return e.userCode !== item.userCode;
                });
                this.seletPerson = b;
            }
            this.personNum = this.seletPerson.length;
        }
    }
};
</script>
<style lang="less">
#add-org-group {
  .dialog-body {
    width: 80%;
    height: 160px;
    // display: flex;
  }
  .left {
    width: 30%;
    height: 100%;
    border-right: 1px solid #e6e6e6;
    .left-head {
      background-color: #f2f2f2;
      height: 40px;
      line-height: 40px;
      color: #666666;
      font-size: 14px;
      padding-left: 15px;
    }
    .left-tree {
      height: 100%;
      overflow: auto;
    }
  }
  .mid {
    width: 40%;
    height: 100%;
    border-right: 1px solid #e6e6e6;
    .mid-head {
      height: 40px;
      display: flex;
      align-items: center;
      background-color: #f2f2f2;
      justify-content: flex-end;
      padding-right: 20px;
    }
    .mid-content {
      height: 100%;
      overflow: auto;
    }
    .el-checkbox {
      margin-left: 10px;
      margin-right: 15px;
    }
    .name {
      width: 60px;
      margin-left: 10px;
      margin-right: 10px;
    }
    .name-tip{color:#999999}
    .mid-person {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .icon {
        font-size: 14px;
        width: 16px;
        height: 16px;
      }
    }
    .mid-content .box-person:nth-child(even){
      background: #f9f9f9;
    }
    .box-person{
      height: 40px;
     display: flex;
     }
  }
  .right {
    width: 30%;
    height: 100%;
    .checked-list-select {
      display: flex;
      justify-content: center;
      height: 40px;
    }
    .checked-list-title {
      width: 100%;
      height: 40px;
      background-color: #f2f2f2;
      line-height: 38px;
      color: #666666;
      padding: 0 10px 0 20px;
      box-sizing: border-box;
    }
    .checked-num i {
      font-style: normal;
      color: #3ea4eb;
    }
    .clear-all {
      float: right;
      cursor: pointer;
    }
    .right-content {
      height: calc(100% - 70px);
      overflow: auto;
      .right-name{
        padding-left:10px
      }
    }
    .line-content {
      height: 40px;
      display: flex;
      align-items: center;
      .icon {
        font-size: 14px;
        width: 16px;
        height: 16px;
      }
      .person-sex {
        width: 80%;
        padding-left: 20px;
      }
      .person-del {
        width: 20%;
        text-align: right;
        cursor: pointer;
        .el-icon-close {
          padding-right: 10px;
        }
      }
    }
  }
  .option-select{width: 220px;}
   .icon-color{color: #58bc58;}
}
</style>